import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { isDisabled } from 'app/infrastructure/data/date';
import { Tag } from 'app/components/tag';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/external-url-groups/list/types-store';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, translation, deleteExternalUrl
}) => {

  const handleDelete = () => {
    deleteExternalUrl(
      item.id,
      item.description,
      translation.external_url_deleted
    );
  };

  return <div className={styles.externalUrlRow}>
    <Link
      className={`${styles.container} ${deleting ? styles.disabled : ''}`}
      to={routeConstants.externalUrlGroupsEditFor(item.id)}>
      <div className={styles.content}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            <div className={`${styles.defaultColumn} d-block`}>
              {item.description} <div className="d-inline-block">
                {deleting && <CodetableItemLoader />}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rightSide}>
          {isDisabled(item.disabled)
            ? <Tag className={styles.disabledTag}>
              {translation.disabled}
            </Tag> : null}
        </div>
      </div>
    </Link>
    {item.id !== 0 && !deleting
      ? <MeatballMenu
        id={`meatball-${item.id}`}
        className={styles.meatball}>
        <li>
          <PromptConfirmationModal
            title={translation.delete_external_url_title}
            description={replaceTemplateString(
              translation.delete_confirmation,
              item?.description)}
            continueText={translation.delete}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button"
              className="dropdown-item"
              disabled={deleting}>
              {translation.delete}
            </button>
          </PromptConfirmationModal>
        </li>
      </MeatballMenu> : null}
  </div>;
};
